module.exports = __webpack_public_path__ + "resources/img/main_banner_cloud03_m.75de3db50c476ab4abc7f34791bd03dc.png";